// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* UE要求取消所有点击动画 */\n\n/* https://github.com/ant-design/ant-design/issues/951 */\n[ant-click-animating-without-extra-node=\"true\"]::after,\n.ant-click-animating-node {\n    animation: none !important;\n    animation-fill-mode: none !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
